import React from "react";

export default class SocialsDumpsters extends React.Component {

    render() 
    {   
        return (        
            <ul className="socials">
                <li>
                    <img className="logo-footer-img" src="/images/logo-dumpster.webp" alt="Hometown Dumpster Rental official logo"></img>
                </li>
                <li className="front-li social">
                    <a className="facebook" role="button" aria-label="facebbok" rel="noreferrer" href="https://www.facebook.com/HometownDumpsterRental/" target="_blank"/>
                    <a className="twitter" role="button" aria-label="x (Twitter)" rel="noreferrer" href="https://x.com/hometowndumpstr" target="_blank"/>
                    <a className="pinterest" role="button" aria-label="pinterest" rel="noreferrer" href="https://www.pinterest.com/hometowndiytips/" target="_blank"/>          
                    <a className="youtube" role="button" aria-label="youtube" rel="noreferrer" href="https://www.youtube.com/c/HometownDumpsterRental" target="_blank"/>
                </li>
            </ul>
        );
    }
}